import styled from 'styled-components';

export const ButtonBaseStyled = styled.div`
  .btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 0;

    &.homecare-btn {
      background: ${({ theme }) => theme?.blue?.royal};
      border-color: ${({ theme }) => theme?.blue?.royal};

      &:hover {
        background: ${({ theme }) => theme?.blue?.royal};
        border-color: ${({ theme }) => theme?.blue?.royal};
      }
    }

    &.btn-sm {
      font-size: 14px;
    }

    .left {
      margin-right: 7px;
      display: flex;
    }
    .right {
      margin-left: 10px;
      display: flex;
    }

    .normalIcon {
      display: flex;
    }

    &.hasHoverIcon {
      .normalIcon {
        display: block;
      }
      .hoveredIcon {
        display: none;
      }
      &:hover {
        .normalIcon {
          display: none;
        }
        .hoveredIcon {
          display: block;
        }
      }
    }
  }
`;
